import React, { useEffect, useState } from 'react';
import { withErrorHandler } from '../../../..';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Header from '../../../common/components/Header/Header';
import { navigate } from 'gatsby-link';
import {
  getCompanyTypeList,
  breIndustryRules,
  getIndustryBreRules
} from '../../../common/constants/api';
import CommonToggleButton from '../../../components/Dashboard-res/CommonComponent/CommonToggleButton';
import ConfirmationModal from '../../../common/components/Modal/ConfirmationModal';

const AllowedIndustry = () => {
  const [companyTypes, setCompanyTypes] = useState([]);
  const [companyRules, setCompanyRules] = useState([]);
  const [ruleChange, setRuleChange] = useState({});
  const [changesSaved, setChangesSaved] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [industryType, setIndustryType] = useState('');
  const [applySaveRisk, setApplySaveRisk] = useState('');

  const getIndustryRules = () => {
    getIndustryBreRules().then(res => {
      setCompanyRules(res);
    });
  };

  useEffect(() => {
    getCompanyTypeList().then(res => setCompanyTypes(res));
    getIndustryRules();
  }, []);

  const saveChanges = async ruleChange => {
    await breIndustryRules(ruleChange)
      .then(res => setChangesSaved(!changesSaved))
      .catch(err => {});
  };

  useEffect(() => {
    saveChanges(ruleChange);
  }, [ruleChange]);

  useEffect(() => {
    getIndustryRules();
  }, [changesSaved]);

  const handleClickYes = () => {
    setRuleChange({
      industryType: industryType,
      applySaveRisks: applySaveRisk
    });
    setShowModal(false);
  };

  return (
    <div className="w-full bg-navy-600">
      <Helmet title={`Industry BRE | ${siteTitle}`} />
      <div className="flex w-full">
        <Sidebar />
        <div className="w-full max-h-screen overflow-auto">
          <Header />
          <div className="w-full px-4 pt-20 md:pt-0">
            <div className="hidden md:block mr-auto text-black-1011 text-sm">
              <span
                onClick={() => navigate('/app/bre')}
                className="text-blue-1301 cursor-pointer"
              >
                BRE
              </span>
              <ChevronRightIcon /> Industry
            </div>
            <div className="bg-white px-2  py-4 rounded  mt-5">
              <p className="text-base font-semibold text-grey-2000 mt-2 mb-9 text-justify pl-3 pr-4">
                If Type of Employer is from the below mentioned then only we can
                apply Save Risk Checks
              </p>
              <div className="px-3 my-3 text-grey-2000">
                {companyTypes.map((each, i) => (
                  <div key={`industry${i}`}>
                    <div className="flex justify-between h-10">
                      <p style={{ minWidth: '80%' }}>{each?.name}</p>
                      <CommonToggleButton
                        name={each?.name}
                        labelName=""
                        Id={each?.name}
                        labelFor={each?.name}
                        checked={
                          companyRules.find(
                            ({ industryType }) => industryType === each?.name
                          )?.applySaveRisks
                        }
                        stylesContainer={{
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          marginLeft: '1.3rem'
                        }}
                        onChange={e => {
                          setIndustryType(each?.name);
                          setApplySaveRisk(e.target.checked);
                          setShowModal(true);
                        }}
                      />
                    </div>
                    <hr
                      className="w-full mb-6"
                      style={{ borderColor: '#dee0f0' }}
                    />
                  </div>
                ))}
              </div>
              <ConfirmationModal
                headText=""
                bodyText="This will change the Industry type access."
                proceedTextShow={true}
                buttonShow={true}
                handleClickYes={handleClickYes}
                askConfirmation={showModal}
                setConfirmation={setShowModal}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withErrorHandler(AllowedIndustry);
